/**
 * @generated SignedSource<<ca94f3eb4c4f2ac91a195aaa1a3114ed>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TranscriptVideo_meetingRecording$data = {
  readonly __typename: string;
  readonly clips?: ReadonlyArray<{
    readonly id: string;
  }> | null;
  readonly didViewerAttend?: boolean | null;
  readonly id: string;
  readonly userVideoProgress?: number;
  readonly " $fragmentSpreads": FragmentRefs<"Video_meetingRecording">;
  readonly " $fragmentType": "TranscriptVideo_meetingRecording";
};
export type TranscriptVideo_meetingRecording$key = {
  readonly " $data"?: TranscriptVideo_meetingRecording$data;
  readonly " $fragmentSpreads": FragmentRefs<"TranscriptVideo_meetingRecording">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "public"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "TranscriptVideo_meetingRecording",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "__typename",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "userVideoProgress",
          "storageKey": null
        },
        {
          "condition": "public",
          "kind": "Condition",
          "passingValue": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "MeetingRecordingClip",
              "kind": "LinkedField",
              "name": "clips",
              "plural": true,
              "selections": [
                (v0/*: any*/)
              ],
              "storageKey": null
            }
          ]
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "didViewerAttend",
          "storageKey": null
        }
      ],
      "type": "MeetingRecording",
      "abstractKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "Video_meetingRecording"
    }
  ],
  "type": "MeetingRecordingInterface",
  "abstractKey": "__isMeetingRecordingInterface"
};
})();

(node as any).hash = "92275514371f69a5c887ab8cd637b7e1";

export default node;
